
/**
 * Body
 */
import Body1 from "./icons/body-1.svg";
import Body2 from "./icons/body-2.svg";
import Body3 from "./icons/body-3.svg";
import Body4 from "./icons/body-4.svg";
import Body5 from "./icons/body-5.svg";
import Body6 from "./icons/body-6.svg";
import Body7 from "./icons/body-7.svg";
import Body8 from "./icons/body-8.svg";
import Body9 from "./icons/body-9.svg";
import Body10 from "./icons/body-10.svg";
import Body11 from "./icons/body-11.svg";
import Body12 from "./icons/body-12.svg";
import Body13 from "./icons/body-13.svg";
import Body14 from "./icons/body-14.svg";
import Body15 from "./icons/body-15.svg";
import Body16 from "./icons/body-16.svg";
import Body17 from "./icons/body-17.svg";
import Body18 from "./icons/body-18.svg";
import Body19 from "./icons/body-19.svg";
import Body20 from "./icons/body-20.svg";
import Body21 from "./icons/body-21.svg";
import Body22 from "./icons/body-22.svg";
import Body23 from "./icons/body-23.svg";
import Body24 from "./icons/body-24.svg";
import Body25 from "./icons/body-25.svg";
import {shiftOfObject} from "@gqlapp/utils/filterObject";



/**
 * BodyShape
 * @type {({icon: *})[]}
 */
export const BodyShape = [
  { title: `default`, icon: Body1, has_data: true, dataSize: 100,  },
  { title: `body1`, icon: Body2 },
  { title: `body2`, icon: Body3, has_data: true},
  { title: `body3`, icon: Body4 },
  { title: `body4`, icon: Body5 },
  { title: `body5`, icon: Body6 },
  { title: `body6`, icon: Body7 },
  { title: `body7`, icon: Body8 },
  { title: `body8`, icon: Body9 },
  { title: `body9`, icon: Body10 },
  { title: `body10`, icon: Body11 },
  { title: `body11`, icon: Body12 },
  { title: `body12`, icon: Body13 },
  { title: `body13`, icon: Body14 },
  { title: `body14`, icon: Body15 },
  { title: `body15`, icon: Body16 },
  { title: `body16`, icon: Body17 },
  { title: `body17`, icon: Body18 },
  { title: `body18`, icon: Body19 },
  { title: `body19`, icon: Body20 },
  { title: `body20`, icon: Body21, has_data: true },
  { title: `body21`, icon: Body22, has_data: true },
  { title: `body22`, icon: Body23, has_data: true },
  { title: `body23`, icon: Body24, has_data: true },
  { title: `body24`, icon: Body25, has_data: true }
];


export default function getBody(style:any){
  let _OPTS = {};
  let body_lists = [...BodyShape].sort((a, b) => {
    if (a.title === 'default') return 1;  // a đứng sau
    if (b.title === 'default') return -1; // b đứng sau
    return 0; // giữ nguyên thứ tự các phần tử còn lại
  })

  body_lists.map(({ title, ...values })=>{
    _OPTS[title] = Object.assign(values, { title });
  });


  if(isNumber(style) && (style = parseInt(style))){
    if(style === 0){ style = `default`; }
    else if(style < 25){ style = `body${style}` }else { style = `default`; }
  }


  return shiftOfObject(_OPTS, function ($value: any, $key: string){
    return !!$value && [`${style}`, 'default'].includes($key);
  });
}